module.exports = __webpack_public_path__ + "static/media/no-image.42d08e65.png";